export const SUBSCRIPTION_STORAGE_KEYS = {
  result: 'subscription',
  pending: 'unverifiedSubscription',
  errorCode: 'errorSubscriptionCode',
  apvStatus: 'apvStatus',
} as const;
